import React, { Suspense, lazy } from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes, portalRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import PortalProtectedRoute from './PortalProtectedRoute';
import AppRoute from './AppRoute';
import Loading from 'components/shared-components/Loading';

const PortalLayout = lazy(() => import('layouts/PortalLayout'));

const Routes = () => {

	return (
		<RouterRoutes>
			{/* Redirect root to dashboard */}
			<Route path="/" element={<Navigate to={AUTHENTICATED_ENTRY} replace />} />
			
			{/* Public routes */}
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route 
							key={route.path || route.key} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
			</Route>

			{/* Portal protected routes (client users) */}
			<Route element={<PortalProtectedRoute />}>
				{portalRoutes.map((route, index) => {
					return (
						<Route
							key={route.key + index}
							path={route.path}
							element={
								<Suspense fallback={<Loading cover="content" />}>
									<PortalLayout>
										<route.component />
									</PortalLayout>
								</Suspense>
							}
						/>
					)
				})}
			</Route>

			{/* Protected routes */}
			<Route element={<ProtectedRoute />}>
				{protectedRoutes.map((route, index) => {
					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
			</Route>
		</RouterRoutes>
	)
}

export default Routes